import { FIELD_TYPES } from '../constants/field-types';
import { uploadFile } from '../fields/file-upload/file-upload-actions';
export const FIELD_ASYNC_ACTIONS = {
  [FIELD_TYPES.FILE_UPLOAD]: {
    uploadFile
  },
  [FIELD_TYPES.QUIZ_FILE_UPLOAD]: {
    uploadFile
  },
  [FIELD_TYPES.SIGNATURE]: {
    uploadFile
  }
};
//# sourceMappingURL=field-async-actions.js.map